import { isDynamicToolUIPart, isToolUIPart, type UIMessage } from 'ai';
import { ToolCallCard } from './ToolCallCard';

type Part = UIMessage['parts'][number];

/** True for both our MCP tools (dynamic-tool parts, since the backend wraps them with dynamicTool)
 * and any future statically-typed tool-* parts. */
export function isToolPart(part: Part): boolean {
  return isDynamicToolUIPart(part) || isToolUIPart(part);
}

/** Renders one tool call as the chat {@link ToolCallCard}. Dynamic-tool parts carry their name
 * directly; statically-typed `tool-<name>` parts derive it from the part type. */
export function ToolMessagePart({ part }: { part: Part }) {
  if (isDynamicToolUIPart(part)) {
    return (
      <ToolCallCard
        toolName={part.toolName}
        state={part.state}
        input={part.input}
        output={part.output}
        errorText={part.errorText}
      />
    );
  }

  if (isToolUIPart(part)) {
    return (
      <ToolCallCard
        toolName={part.type.split('-').slice(1).join('-')}
        state={part.state}
        input={part.input}
        output={part.output}
        errorText={part.errorText}
      />
    );
  }

  return null;
}
